import { TextFieldProps, TextField as TF } from "@mb-pro-ui/components/form";
import { styled } from "@mui/material";

export const TextField = styled(({ sx, size, ...props }: TextFieldProps) => (
  <TF {...props} size={size} sx={{ "& .MuiInputBase-input": size === "small" ? { pt: "22px", pb: "3px" } : {pt: "24px", pb: "6px" }, ...sx }} />
))({});
